import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { mixWithBlack, readableOn } from '@/lib/branding';
import { cn } from '@/lib/cn';
import { initials } from '@/lib/format';

export function Avatar({
  name,
  src,
  className,
  color,
}: {
  name: string;
  src?: string | null | undefined;
  className?: string;
  /** background for the initials fallback (e.g. tenant brand colour) */
  color?: string | undefined;
}) {
  // Tenant colours can be anything: render them as the app's solid shade and pick the readable text.
  const fill = color ? mixWithBlack(color, 82) : undefined;
  return (
    <AvatarPrimitive.Root
      className={cn(
        'relative inline-flex size-8 shrink-0 overflow-hidden rounded-full select-none',
        className,
      )}
    >
      {src && <AvatarPrimitive.Image src={src} alt="" className="size-full object-cover" />}
      <AvatarPrimitive.Fallback
        delayMs={src ? 300 : 0}
        className="flex size-full items-center justify-center bg-linear-to-br from-primary to-brand-strong text-[0.7em] font-semibold text-white"
        style={fill ? { background: fill, color: readableOn(fill) } : undefined}
      >
        <span aria-hidden>{initials(name)}</span>
        <span className="sr-only">{name}</span>
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
}
